module.exports = __webpack_public_path__ + "img/avatar.f155a51c.png";